import React, { useState, useEffect, useRef } from "react";
import "./NewMultiSelectSearch.css";
import { SvgLocation, SvgMap } from "../../utils/svgIcons";

const NewMultiSelectSearchHolidays = ({
  type,
  onMultiSelectionChange,
  onClick,
  className,
  package_type,
  defaultSelected = [],
  width,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);
  const [filtered, setFilteredData] = useState([]);
  const [selectedDestinations, setSelectedDestinations] =
    useState(defaultSelected);

  // useEffect(() => {
  //   const filteredD = filtered?.filter((item) =>
  //     item.name.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  //   setResults(filteredD);
  // }, [searchQuery]);

  const [isLoading, setIsLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);

  useEffect(() => {
    // Sync defaultSelected with selectedDestinations
    if (defaultSelected.length > 0) {
      setSelectedDestinations(defaultSelected);
    }
  }, [defaultSelected.length]);

  // Fetch destination API
  const fetchDestination = async (destination) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    // const raw = JSON.stringify({ search: destination, type });

    const raw = JSON.stringify({
      search: destination,
      // type: type,
      // package_type: package_type
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/destinations/fetch`,
        requestOptions
      );
      const result = await response.json();
      if (result?.data) {
        setResults(result.data);
        setFilteredData(result.data);
        setIsPopupOpen(true); // Show popup when results are available
      }
    } catch (error) {
      console.error("Error fetching destinations:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (query.trim()) {
      fetchDestination(query);
    } else {
      setResults([]);
      // setFilteredData
      setIsPopupOpen(false);
    }
  };

  const handleToggle = (destination) => {
    setSelectedDestinations((prev) =>
      prev.includes(destination)
        ? prev.filter((d) => d !== destination)
        : [...prev, destination]
    );
    setSearchQuery("");
  };

  useEffect(() => {
    if (onMultiSelectionChange) {
      onMultiSelectionChange(selectedDestinations);
    }
  }, [selectedDestinations, onMultiSelectionChange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRemoveDestination = (destination) => {
    setSelectedDestinations((prev) => prev.filter((d) => d !== destination));
  };

  return (
    <div className={`relative ${className} p_0`}>
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        {selectedDestinations && selectedDestinations.length > 0 && (
          <div
            className="selected-destinations_new"
            style={{
              maxWidth: "222px",
              minWidth:
                selectedDestinations && selectedDestinations.length > 0
                  ? "60px"
                  : "100%",
            }}
          >
            {selectedDestinations.map((destination, index) => (
              <span className="selected-destinations_new_inner_div" key={index}>
                <span> {destination} </span>
                <span
                  className="pointer"
                  onClick={() => handleRemoveDestination(destination)}
                  style={{ marginLeft: "5px" }}
                >
                  X
                </span>
              </span>
            ))}
          </div>
        )}
        <input
          // style={{
          //   width:
          //     selectedDestinations && selectedDestinations.length > 0
          //       ? "20%"
          //       : "100%",
          // }}
          type="text"
          placeholder={
            selectedDestinations && selectedDestinations.length > 0
              ? ""
              : "Where would you like to go?"
          }
          value={searchQuery}
          onChange={handleSearchChange}
          className={`search_form_input m_0 ${className}`}
          onClick={onClick}
        />

        {width <= 640 && <SvgMap />}
      </div>

      {/* {isLoading && <p>Loading...</p>} */}
      {isPopupOpen && results.length > 0 && (
        <div
          ref={popupRef}
          className="search_list_TransportNew"
          style={{ top: selectedDestinations.length > 0 ? "39px" : "39px" }}
        >
          {results.map((destination, index) => (
            <div key={index} onClick={() => handleToggle(destination.name)}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                {/* <input
                  type="checkbox"
                  checked={selectedDestinations.includes(destination.name)}
                  onChange={() => handleToggle(destination.name)}
                  style={{ marginRight: "6px" }}
                /> */}
                <SvgLocation />
                {destination.name}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NewMultiSelectSearchHolidays;
